import styled from '@emotion/styled';

export const Content = styled.div`
  padding: ${({ theme }) => `${theme.space.xxxl}px`} 0
    ${({ theme }) => `${theme.space.m}px`};
  width: 100%;
  max-width: 700px;
`;
